var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('label',{staticClass:"label",attrs:{"for":_vm.labelFor}},[_vm._v(" "+_vm._s(_vm.labelText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }